/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import {
    ALL_PERMIT_TYPES_MAPPING,
    CLEAR_CREEK_PERMIT_TYPES,
    FLORIDA_OHV_PERMIT_TYPES,
} from '../../utils/utils';
import RegVehicleInfoForm from './RegVehicleInfoForm';
import AtvVehicleInfoFrom from './AtvVehicleInfoForm';

const VEHICLE_INFORMATION_PROP_PATH = 'vehicle_information';

export default class VehicleInformation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
        this.handleVehicleDetailsChange = this.handleVehicleDetailsChange.bind(this);
        this.changeVehicleSelection = this.changeVehicleSelection.bind(this);
        this.onFormValidate = this.onFormValidate.bind(this);
    }

    onFormValidate(isInValid, error, path) {
        if (isInValid) {
            this.props.pActions.formValidationChange(
                `${this.props.reservation.id}_${path}`,
                error
            );
        } else {
            this.props.pActions.formValidationChange(
                `${this.props.reservation.id}_${path}`,
                null
            );
        }
    }

    handleVehicleDetailsChange(path, value) {
        this.props.pActions.updatePendingReservation(
            this.props.reservation.id,
            path,
            value
        );
    }

    changeVehicleSelection(e) {
        this.props.pActions.updatePendingReservation(
            this.props.reservation.id,
            `${VEHICLE_INFORMATION_PROP_PATH}.make`,
            e.target.value
        );
    }

    render() {
        const { reservation } = this.props;

        switch (reservation.permit_type) {
            case ALL_PERMIT_TYPES_MAPPING[CLEAR_CREEK_PERMIT_TYPES.ACEC_PERMIT]:
                return null;
            case ALL_PERMIT_TYPES_MAPPING[CLEAR_CREEK_PERMIT_TYPES.ATV_PERMIT]:
                return (
                    <AtvVehicleInfoFrom
                        reservation={reservation}
                        validation={this.props.validation}
                        addToInputRefs={this.props.addToInputRefs}
                        vIndex={this.props.vIndex}
                        onFormValidate={this.onFormValidate}
                        displayValidationError={this.props.displayValidationError}
                        changeVehicleSelection={this.changeVehicleSelection}
                    />
                );
            case ALL_PERMIT_TYPES_MAPPING[FLORIDA_OHV_PERMIT_TYPES.OHV_ANNUAL_PERMIT]:
            case ALL_PERMIT_TYPES_MAPPING[FLORIDA_OHV_PERMIT_TYPES.OHV_SEVEN_DAYS_PERMIT]:
            case ALL_PERMIT_TYPES_MAPPING[FLORIDA_OHV_PERMIT_TYPES.OHV_THREE_DAYS_PERMIT]:
                return (
                    <RegVehicleInfoForm
                        reservation={reservation}
                        validation={this.props.validation}
                        driverLicenseRequired
                        enforceValidation
                        addToInputRefs={this.props.addToInputRefs}
                        vIndex={this.props.vIndex}
                        handleVehicleDetailsChange={this.handleVehicleDetailsChange}
                    />
                );
            default:
                return (
                    <RegVehicleInfoForm
                        reservation={reservation}
                        validation={this.props.validation}
                        enforceValidation
                        addToInputRefs={this.props.addToInputRefs}
                        vIndex={this.props.vIndex}
                        handleVehicleDetailsChange={this.handleVehicleDetailsChange}
                    />
                );
        }
    }
}

VehicleInformation.propTypes = {
    reservation: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    pActions: PropTypes.object.isRequired,
    displayValidationError: PropTypes.bool,
};
